<template>
    <div :class="['app-auth-page', 'reg-bg']">
        <div id="components-section">
            <verify></verify>
        </div>
    </div>
</template>

<script>
import verify from "@/components/SignIn/PhoneAuth.vue";

export default {
    components: {
        verify,
    },
};
</script>

<style lang="scss" scoped>
.app-auth-page {
    // background: no-repeat 0 50%;
    // background-size: cover;
    background-color: #f8f8f8;
    min-width: 100vw;
    min-height: 100vh;
    text-align: center;
    position: relative;

    @media screen and (max-width: 600px) {
        padding: 3px !important;
    }

    #white-section {
        background-color: white;
        min-width: 500px;
        width: 200vw;
        height: 250px;
        transform: rotate(3deg);
        margin-left: -25px;
    }

    .banner {
        width: 414px;
        height: 200px;
        display: inline-block;
        transform: rotate(-3deg);
    }

    .image {
        width: 414px;
        margin-top: 50px;
        margin-left: calc(25% - 207px);
    }
}
</style>
